import useScrollToTop, { useScrollToTopOnce } from '../hooks/use-scroll-to-top';

const ScrollToTop = ({ behavior }: { behavior?: ScrollBehavior }) => {
	useScrollToTop({ behavior });
	return null;
};

export const ScrollToTopOnce = ({ behavior }: { behavior?: ScrollBehavior }) => {
	useScrollToTopOnce({ behavior });
	return null;
};

export default ScrollToTop;
